/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Input Event Icon component.
 */
export const MapInputEventIcon = (props: IconProps) => {
  const {iconSize} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_23332_6401)'>
        <path fillRule='evenodd' clipRule='evenodd' d='M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C23.9927 5.37563 18.6244 0.00734817 12 0Z' fill='white' />
        <path fillRule='evenodd' clipRule='evenodd' d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2.00619 17.5203 6.47972 21.9938 12 22Z' fill='#8C18F2' />
        <path d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z' fill='#8C18F2' />
        <path d='M9 7C8.08852 7.50427 7.33107 8.23226 6.80427 9.11026C6.27748 9.98826 6 10.9851 6 12C6 13.0149 6.27748 14.0118 6.80427 14.8898C7.33107 15.7678 8.08852 16.4957 9 17' stroke='white' strokeWidth='2' strokeMiterlimit='10' strokeLinecap='round' />
        <path d='M15 7C15.9115 7.50427 16.6689 8.23226 17.1957 9.11026C17.7225 9.98826 18 10.9851 18 12C18 13.0149 17.7225 14.0118 17.1957 14.8898C16.6689 15.7678 15.9115 16.4957 15 17' stroke='white' strokeWidth='2' strokeMiterlimit='10' strokeLinecap='round' />
        <path d='M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z' fill='white' stroke='white' />
      </g>
      <defs>
        <clipPath id='clip0_23332_6401'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MapInputEventIcon;
